import React from "react";
import "../CSS/TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-conditions-container">
      <header className="terms-conditions-header">
        <h1 className="terms-conditions-title">Terms & Conditions</h1>
        <p className="terms-conditions-subtitle">Your agreement to use our services</p>
      </header>
      
      <div className="terms-conditions-content">
  <p>Last updated: September 10, 2025</p>

  <p>These Terms and Conditions (“Terms”) are a general agreement that govern your access to and use of our websites, applications, and related services (the “Services”). By accessing or using the Services, you agree to be bound by these Terms. If you do not agree, do not use the Services.</p>

  <h4>1. Eligibility and Accounts</h4>
  <p>You must be legally able to form a binding contract to use the Services. To access certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your credentials and for all activities under your account.</p>

  <h4>2. Acceptable Use</h4>
  <p>You agree not to misuse the Services. Prohibited conduct includes, without limitation: violating laws; infringing third-party rights; attempting to access accounts or systems without authorization; introducing viruses or malicious code; interfering with the operation or security of the Services; or using the Services to send spam or fraudulent content.</p>

  <h4>3. Your Content</h4>
  <p>You may submit, upload, or otherwise make content available through the Services. You retain any ownership rights you have in your content, but grant us a non-exclusive, worldwide, royalty-free license to use, host, reproduce, modify, and display your content as necessary to provide and improve the Services.</p>

  <h4>4. Our Intellectual Property</h4>
  <p>The Services, including all software, content, and materials, are owned by us or our licensors and are protected by intellectual property laws. Except as expressly permitted, you may not copy, modify, distribute, sell, or lease any part of the Services.</p>

  <h4>5. Third-Party Services</h4>
  <p>The Services may include links to or integrations with third-party services. We are not responsible for third-party services and your use of them is at your own risk and subject to their terms and policies.</p>

  <h4>6. Disclaimers</h4>
  <p>The Services are provided “as is” and “as available” without warranties of any kind, whether express or implied, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that the Services will be uninterrupted, secure, or error-free.</p>

  <h4>7. Limitation of Liability</h4>
  <p>To the maximum extent permitted by law, we will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or loss of data, use, goodwill, or other intangible losses, resulting from your use of or inability to use the Services.</p>

  <h4>8. Indemnification</h4>
  <p>You agree to defend, indemnify, and hold harmless us and our affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys’ fees, arising out of or in any way connected with your use of the Services or your violation of these Terms.</p>

  <h4>9. Termination</h4>
  <p>We may suspend or terminate your access to the Services at any time for any reason, including if we reasonably believe you have violated these Terms. Upon termination, your right to use the Services will cease immediately.</p>

  <h4>10. Governing Law</h4>
  <p>These Terms are governed by the laws of your principal place of business (or, if unspecified, our place of incorporation), without regard to conflict of law rules. Venue for any disputes will be in the competent courts of that jurisdiction.</p>

  <h4>11. Changes to These Terms</h4>
  <p>We may modify these Terms from time to time. If we make material changes, we will update the “Last updated” date and, where appropriate, provide additional notice. Your continued use of the Services after changes become effective constitutes acceptance of the updated Terms.</p>

  <h4>12. Contact Us</h4>
  <p>If you have any questions about these Terms, contact us at: <strong>support@example.com</strong></p>
      </div>
    </div>
  );
};

export default TermsAndConditions;

